import moment from 'moment-timezone';
import Constants from "../Constants";

// import { Buffer } from 'buffer';
export const PROJECT_DATE_FORMAT="M-D-YYYY";

export const decodeHtml = (str) => {
    return str.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');

    // let txt = new DOMParser().parseFromString(str, "text/html");
    
    // return txt.documentElement.textContent;
    
    }

export const getDateTimestamp = (date) => {
    if (date) {
        if (date?.utcTimestamp) {
            return date?.utcTimestamp;
        } else if(date instanceof Date){
            return date.getTime();
        } else if(moment.isMoment(date)) {
            return date.valueOf();
        } else {
            return date;
        }
    }
    return date;
}

export const dateFormat = (date , format) => {
    date = getDateTimestamp(date);
    // var momentT = require('moment-timezone');
    // return momentT(date).tz('America/Los_Angeles').format(format)
    return moment(date).format(format)
}

export const dateFormatAccToTimeZone = (date , format,timezone) => {
  date = getDateTimestamp(date);
  return moment(date).tz(timezone)?.format(format)
} 

export const getFileExtension = (filename)=>{
  return filename?.substr(filename?.lastIndexOf(".") + 1)
}

export const dateInUTC = (date) => {
  return moment.utc(date).format();
}
export const utcDateTimeWithTimeZone = (date , timeZone) => {
  date = getDateTimestamp(date);
  return moment(date).tz(timeZone)
}
export const utcDateTimeWithTimeZoneWithFormat = (date,format,timeZone) => {
  date = getDateTimestamp(date);
  return moment(date).tz(timeZone)?.format(format)
}

export const addDaysToDate = (date, daysToAdd, format) => {
    return moment(moment(date).add(daysToAdd,'days')).format(format);
}

export const utcTimeStamp=(date,userTimezone)=>{
  date = getDateTimestamp(date);
  const momentDate = moment(date);
 return  momentDate.tz(userTimezone).utc().valueOf();

}

export const addDaysToDateNoFormat = (date, daysToAdd) => {
  date = getDateTimestamp(date);
  return moment(moment(date).add('days', daysToAdd));
}

export const getDateAfterFormat = (date) => {
    date = getDateTimestamp(date);
    return moment(date).format(Constants.DATE_FORMAT);
} 

export const currentDate = () =>{
    return moment().startOf("day");
}
export const currentDateWithFormat = (format) => {
    return moment().format(format);
}
export const earlierDate = (date, diff, format) =>{
    return date.subtract(diff, format);
}

export const dateDifference = (firstDate, lastDate, diffIn) => {
    firstDate = getDateTimestamp(firstDate);
    lastDate = getDateTimestamp(lastDate);
    return moment(firstDate).diff(
        moment(lastDate),
        diffIn,
        true
      );
}
export const dateDifferenceFromToday = (firstDate, diffIn) => {
    firstDate = getDateTimestamp(firstDate);
    if(moment(firstDate) > moment()){
        return Math.abs(moment(firstDate).diff(
            moment(),
            diffIn
          )) + ' Days Left'
    }
    if(moment(firstDate) < moment()){
        return Math.abs(moment(firstDate).diff(
            moment(),
            diffIn
          )) + ' Days Overdue'
    }
    if(moment(firstDate) === moment()){
        return 'Today'
    }
    // else{
    //    return 'EXPIRED'
    // }
    
}
export const autoDateDiff = (dueDate) => {
    dueDate = getDateTimestamp(dueDate);
    var dayDiff = moment(dueDate).diff(moment(),"hour");
    
    if (moment(dueDate) === moment()) {
        return "Today";
      }
  if (moment(dueDate) > moment()) {
    if (dayDiff > 0) {
      if (dayDiff < 24) {
        if (Math.floor(dayDiff) > 1) {
          return `In ${Math.floor(dayDiff)} Hours`;
        } else {
          return `In ${Math.floor(dayDiff)} Hour`;
        }
      }
      if (dayDiff > 24 && dayDiff < 7 * 24) {
        if (Math.floor((dayDiff / 7) * 24) > 1) {
          return `In ${Math.floor(dayDiff / 24)} Days`;
        } else {
          return `In ${Math.floor(dayDiff / 24)} Day`;
        }
      }
      if (dayDiff > 6 * 24 && dayDiff < 30 * 24) {
        if (Math.floor((dayDiff ) * 0.00595238) > 1) {
          return `In ${Math.floor((dayDiff) * 0.00595238)} Weeks`;
        } else {
          return `In ${Math.floor((dayDiff) * 0.00595238)} Week`;
        }
      }
      if (dayDiff > 30 * 24 && dayDiff < 365 * 24) {
        if (Math.floor((dayDiff * 0.00136986) ) > 1) {
          return `In ${Math.floor((dayDiff * 0.00136986) )} Months`;
        } else {
          return `In ${Math.floor((dayDiff * 0.00136986))} Month`;
        }
      } else {
        if (Math.floor((dayDiff / 365) * 24) > 1) {
          return `In ${Math.floor((dayDiff) * 0.000114155)} Years`;
        } else {
          return `In ${Math.floor((dayDiff) * 0.000114155)} Year`;
        }
      }
    } 
  }
  else {
    dayDiff = Math.abs(dayDiff);
    if (dayDiff <= 24) {
        if (Math.floor(dayDiff) > 1) {
          return `${Math.floor(dayDiff)} Hours ago`;
        } else {
          return `${Math.ceil(dayDiff)} Hour ago`;
        }
      }
      if (dayDiff > 24 && dayDiff < 7 * 24) {
        if (Math.floor((dayDiff / 7) * 24) > 1) {
          return `${Math.floor(dayDiff / 24)} Days ago`;
        } else {
          return `${Math.ceil(dayDiff / 24)} Day ago`;
        }
      }
      if (dayDiff >= 7 * 24 && dayDiff <= 30 * 24) {
        if (Math.floor((dayDiff ) * 0.00595238) > 1) {
          return `${Math.floor((dayDiff) * 0.00595238)} Weeks ago`;
        } else {
          return `${Math.ceil((dayDiff) * 0.00595238)} Week ago`;
        }
      }
      if (dayDiff > 30 * 24 && dayDiff <= 364 * 24) {
        if (Math.floor((dayDiff * 0.00136986) ) > 1) {
          return `${Math.floor((dayDiff * 0.00136986) )} Months ago`;
        } else {
          return `${Math.ceil((dayDiff * 0.00136986))} Month ago`;
        }
      } else {
      if (Math.floor((dayDiff / 365) * 24) >= 1) {
        return `${Math.floor((dayDiff) * 0.000114155)} Years ago`;
      } else {
       
        return `${Math.ceil((dayDiff) * 0.000114155)} Year ago`;
      }
    }
  }
};

export const compareDateWithCurrent = (date,format) => {
    date = getDateTimestamp(date);
    return  moment(date).format(format) === moment().format(format)
}
export const compareDates = (date1,date2) => {
  date1 = getDateTimestamp(date1);
  date2 = getDateTimestamp(date2);
  return  moment(date1) - moment(date2)
}
export const checkDateExpired = (date,format) =>{
    date = getDateTimestamp(date);
    var today = moment();
     var bidDate = moment(date);
    if(format !== ''){
      return  today.diff(bidDate,format) >= 0
    }else{
      return  today.diff(bidDate,'days') >= 0
    }
     
    
}
export const checkUpdateBidDateDisabledCondition = (project,bidDueDate,deliveryDueDate) =>{
  var projectBiddueDateExpired = checkDateExpired(project.bidDueDate,'hr')
  var projectDeliveryDueDateExpired = checkDateExpired(project?.deliveryDueDate,'hr')
  var bidDueDateExpired = checkDateExpired(bidDueDate,'hr')
  var bidDeliveryDueDateExpired = checkDateExpired(deliveryDueDate,'hr')
  var validationBidDue = true
  var validationDeliveryDue = true
  
  if(bidDueDate === ""){
    validationBidDue = projectBiddueDateExpired
  }else{
    validationBidDue = bidDueDateExpired
  }
  if(deliveryDueDate === ""){
    validationDeliveryDue = projectDeliveryDueDateExpired
  }else{
    validationDeliveryDue = bidDeliveryDueDateExpired
  }
  return (validationBidDue || validationDeliveryDue)
}

export const dateConvertToTimeStamp = () => {
    let date=new Date();
    return date.getTime();
}

export const campaignDetailDate = (date) => {
    date = getDateTimestamp(date);
    //var momentT = require('moment-timezone');
    //return momentT(date).tz('America/Los_Angeles').format(Constants.DATE_HOUR_MIN_SEC)
    return moment(date).format(Constants.DATE_HOUR_YEAR_MIN_SEC)
}
export const campaignDetailDateWithTimeZone = (date,timeZone) => {
  date = getDateTimestamp(date);
  return moment(date).tz(timeZone)?.format(Constants.DATE_HOUR_YEAR_MIN_SEC)
  
}
export const projectDetailDate = (date,timeZone) => {
    date = getDateTimestamp(date);
    // var momentT = require('moment-timezone');
    return moment(date).tz(timeZone)?.format(Constants.DATE_HOUR_YEAR_MIN_SEC)
    // return  momentT(date).tz('America/Los_Angeles').format(Constants.DATE_HOUR_YEAR_MIN_SEC)
    //return moment(date).format(Constants.DATE_HOUR_YEAR_MIN_SEC)
}
export const dateFormatAndStatus = (date,format,timeZone) =>{
    date = getDateTimestamp(date);
    if(timeZone === undefined){
      if(moment(date).format(format) === moment().format(format)){
        return ([moment(date).format(format),'Today']);
        }
        if(moment(date).format(format) < moment().format(format)){
        return ([moment(date).format(format),'Over Due']);
        }
        if(moment(date).format(format) > moment().format(format)){
        return ([moment(date).format(format),'']);
        }
    }else{
      if(moment(date).tz(timeZone).format(format) === moment().tz(timeZone).format(format)){
      return ([moment(date).tz(timeZone).format(format),'Today']);
      }
      if(moment(date).tz(timeZone).format(format) < moment().tz(timeZone).format(format)){
      return ([moment(date).tz(timeZone).format(format),'Over Due']);
      }
      if(moment(date).tz(timeZone).format(format) > moment().tz(timeZone).format(format)){
      return ([moment(date).tz(timeZone).format(format),'']);
      }
  }

}

export const transformBlankToNull = (obj) => {
    return JSON.parse(JSON.stringify(obj, (key, value) => {
      return (value === "" ? null : value);
    }));
  };

  export const FlatArray = (nestedArray, key, resultArray=[]) => {
    for (let i = 0; i < nestedArray.length; i++) {
      resultArray.push(nestedArray[i]);
      var children = nestedArray[i][key];
    if(children && Array.isArray(children) && children.length > 0){
        FlatArray(children, key, resultArray)
    }
  }
  return resultArray;
}

export const isValidHttpUrl = (urlString) => {
    var url;
    try {
        url = new URL(urlString);
    } catch (_) {
        return false;
    }
    return url.protocol === Constants.HTTP || url.protocol === Constants.HTTPS;
}

export const encodePassword = (password) =>{
    return btoa(encodeURIComponent(password));
}

// export const encodePassword1 = (data) => {
//     return Buffer.from(data).toString('base64');
//   }

 export const TIME_LIST = [
    { value: -1, label: "What time",isDisabled: true },
    { value: 0, label: "Midnight" ,isDisabled: false},
    { value: 1, label: "1 am",isDisabled: false },
    { value: 2, label: "2 am" ,isDisabled: false},
    { value: 3, label: "3 am" ,isDisabled: false},
    { value: 4, label: "4 am" ,isDisabled: false},
    { value: 5, label: "5 am" ,isDisabled: false},
    { value: 6, label: "6 am" ,isDisabled: false},
    { value: 7, label: "7 am" ,isDisabled: false},
    { value: 8, label: "8 am" ,isDisabled: false},
    { value: 9, label: "9 am" ,isDisabled: false},
    { value: 10, label: "10 am" ,isDisabled: false},
    { value: 11, label: "11 am" ,isDisabled: false},
    { value: 12, label: "Noon" ,isDisabled: false},
    { value: 13, label: "1 pm" ,isDisabled: false},
    { value: 14, label: "2 pm" ,isDisabled: false},
    { value: 15, label: "3 pm" ,isDisabled: false},
    { value: 16, label: "4 pm" ,isDisabled: false},
    { value: 17, label: "5 pm" ,isDisabled: false},
    { value: 18, label: "6 pm" ,isDisabled: false},
    { value: 19, label: "7 pm" ,isDisabled: false},
    { value: 20, label: "8 pm" ,isDisabled: false},
    { value: 21, label: "9 pm" ,isDisabled: false},
    { value: 22, label: "10 pm" ,isDisabled: false},
    { value: 23, label: "11 pm" ,isDisabled: false}
  ]

  export const FILE_TYPE_PREF = {
    EXTRACT_XLIFF_FROM_DOCX: "Microsoft Word (.docx, .dotx)",
    EXTRACT_XLIFF_FROM_XLSX: "Microsoft Excel (.xlsx)",
    EXTRACT_XLIFF_FROM_PPTX:"Microsoft Powerpoint (.pptx, .potx)",
    EXTRACT_XLIFF_FROM_IDML :"Adobe InDesign (.idml)",
    ENABLE_IN_CONTEXT_REVIEW_FOR_INDESIGN:"Adobe InDesign Package (.zip)",
    EXTRACT_XLIFF_FROM_HTML:"HTML (.htm, .html)",
    EXTRACT_XLIFF_FROM_XML:"XML (.xml)",
    EXTRACT_XLIFF_FROM_OPENOFFICE:"OpenOffice (.odt, .ods, .odp, .odg)",
    EXTRACT_XLIFF_FROM_JSON:"JSON (.json)",
    EXTRACT_XLIFF_FROM_PROPERTIES:"Java Properties (.properties)",
    EXTRACT_XLIFF_FROM_iOS_MAC_STRINGS:"Apple Strings (.strings)",
    EXTRACT_XLIFF_FROM_SRTFILE:"SRT (.srt)",
    EXTRACT_XLIFF_FROM_VTTFILE:"VTT (.vtt)",
    EXTRACT_XLIFF_FROM_MIF:"Adobe FrameMaker (.mif)",
    EXTRACT_XLIFF_FROM_PHP:"PHP (.php)",
    EXTRACT_XLIFF_FROM_POFILE:"PO Files (.po, .pot)",
    EXTRACT_XLIFF_FROM_YAML:"Rails Yaml Files (.yaml & .yml)",
    EXTRACT_XLIFF_FROM_PLAIN_TEXT:"Text Files (.txt)",
    EXTRACT_XLIFF_FROM_RESX:"RESX (.resx)",
    EXTRACT_XLIFF_FROM_DITA:"DITA (.dita & .ditamap)",
    EXTRACT_XLIFF_FROM_PHOTOSHOP:"Photoshop (.psd)",

  }


  export const FileTypes = ["DOCX", "HTML", "IDML", "JAVA_PROP", "JSON", "MIF", "Open_Office_Files", "PHP", "PO", "POT", "PPTX",
    "PSD", "RAIL", "RESX", "SRT", "STRINGS", "TXT", "XML", "ZIP", "MP4", "PDF", "XLF", "PSD", "VTT", "PPT", "DOC", "XLSX",
    "JPG", "DOTX", "PNG"];

   export const checkPassword=(password,confirmPassword)=>{
    if(password===confirmPassword){
        return true
    }
    return false
   }

   export const isValidWeakPassword =(password) =>{
       if(password.match(/^(?=.*[A-Za-z])(?=.*?[0-9]).{8,}$/)){
        return true;
       }
       return false;
    }

    export const isValidStrongPassword=(password)=>{
        if(password.match(/^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
            return true;
        }
        return false;
    }

    export const passwordLength =(password)=> {
        if (password && password.length > 7) {
            return false;
        }
        return true;
    }

    export const charactersOnly=(password)=>{
        if(password.match(/^(?=.*[A-Za-z])[A-Za-z]{7,}$/)){
            return true
        }
        return false;
    }

    export const numberOnly=(password)=>{
        if(password.match(/[0-9]{7,}$/)){
            return true
        }
        return false;
    }

    export const  discriptionValidation=(discription)=>{
        if(discription.match(/(<([^>]+)>)/ig)){
           return true;
        }  
        return  false;
    }




export const PREF_TYPE_FILE = {
     "Microsoft Word (.docx, .dotx)":"EXTRACT_XLIFF_FROM_DOCX",
     "Microsoft Excel (.xlsx)":"EXTRACT_XLIFF_FROM_XLSX",
    "Microsoft Powerpoint (.pptx, .potx)":"EXTRACT_XLIFF_FROM_PPTX",
    "Adobe InDesign (.idml)":"EXTRACT_XLIFF_FROM_IDML",
    "Adobe InDesign Package (.zip)":"ENABLE_IN_CONTEXT_REVIEW_FOR_INDESIGN",
    "HTML (.htm, .html)":"EXTRACT_XLIFF_FROM_HTML",
    "XML (.xml)":"EXTRACT_XLIFF_FROM_XML",
    "OpenOffice (.odt, .ods, .odp, .odg)":"EXTRACT_XLIFF_FROM_OPENOFFICE",
    "JSON (.json)":"EXTRACT_XLIFF_FROM_JSON",
    "Java Properties (.properties)":"EXTRACT_XLIFF_FROM_PROPERTIES",
    "Apple Strings (.strings)":"EXTRACT_XLIFF_FROM_iOS_MAC_STRINGS",
    "SRT (.srt)":"EXTRACT_XLIFF_FROM_SRTFILE",
    "VTT (.vtt)":"EXTRACT_XLIFF_FROM_VTTFILE",
    "Adobe FrameMaker (.mif)":"EXTRACT_XLIFF_FROM_MIF",
    "PHP (.php)":"EXTRACT_XLIFF_FROM_PHP",
    "PO Files (.po, .pot)":"EXTRACT_XLIFF_FROM_POFILE",
    "Rails Yaml Files (.yaml & .yml)":"EXTRACT_XLIFF_FROM_YAML",
    "Text Files (.txt)":"EXTRACT_XLIFF_FROM_PLAIN_TEXT",
    "RESX (.resx)":"EXTRACT_XLIFF_FROM_RESX",
    "DITA (.dita & .ditamap)":"EXTRACT_XLIFF_FROM_DITA",
    "Photoshop (.psd)":"EXTRACT_XLIFF_FROM_PHOTOSHOP"
}

export const getLoggedInUserRole =  () =>{
  var roleArray = []
  if(localStorage.getItem('role')!==undefined){
  var roles = JSON.parse(localStorage.getItem('role'));
   roles?.map((role)=> {
    roleArray.push(role.value)
    })
  }
return roleArray;
}

export const getOrdinal = (n) =>{
 
    let ord = 'th';
  
    if (n % 10 === 1 && n % 100 !== 11)
    {
      ord = 'st';
    }
    else if (n % 10 === 2 && n % 100 !== 12)
    {
      ord = 'nd';
    }
    else if (n % 10 === 3 && n % 100 !== 13)
    {
      ord = 'rd';
    }
  
    return ord;
  
}
export const subtractMonthsToDate = (noOfMonths) =>{
  var prevDate = moment().subtract(noOfMonths, 'M').startOf('day');
  return prevDate
}
export const subtractDaysToDate = (noOfDays) =>{
  var prevDate = moment().subtract(noOfDays, 'd');
  return prevDate
}

export const encodeString = (string) =>{  
  return string.replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#39;"); 
}

export const humanize = (str) => {
  if (str!== null && str !== "" && str !== undefined) {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] =
        frags[i].charAt(0).toUpperCase() + frags[i].slice(1).toLowerCase();
    }
    return frags.join(" ");
  }
}

export function convertToTitleCase(string) {
  const titleCaseString = string.replace(/([a-z])([A-Z])/g, '$1 $2');
  // Capitalize the first letter of the string
  const capitalizedString = titleCaseString?.charAt(0)?.toUpperCase() + titleCaseString.slice(1);
  return capitalizedString;
}

export const getDepartmentObject=(data)=>{
  let department;
  if(data.length ===1 &&  data[0].name===Constants.UNASSIGNED_DEPARTMENT){
    const departmentToBeSet = data
    const completeDepartmentObject = {
      "path":null,
      "id":departmentToBeSet[0]?.id,
      "name":departmentToBeSet[0]?.name,
      "createdDate":null,
      "systemGroup":false                
    }
    department = completeDepartmentObject;
  }else{
    const departmentToBeSet = data.filter(x=>x?.name !==Constants.UNASSIGNED_DEPARTMENT);
    const completeDepartmentObject = {
      "path":null,
      "id":departmentToBeSet[0]?.id,
      "name":departmentToBeSet[0]?.name,
      "createdDate":null,
      "systemGroup":false                
    }
    department = completeDepartmentObject;
  }
  return department
}

export const openNewTab = (url) => {
  window.open(url, '_blank');
};


export const getRandomColor = () => {
  var letters = '1234567890ABCDEF'.split('');
  var color = '#';
  for (var i = 0; i < 6; i++ ) {
      color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}


export const checkFileSizeInGb=(selectedFile,fileSizePermission)=>{
  //replaced 1024 with 1000 because file of 1.04 gb was also being accepted if limit was of 1 gb.
  const fileSizeInGB = selectedFile.size / (1024 * 1024 * 1024); // Convert bytes to GB
  if (fileSizeInGB > fileSizePermission) {
    return true
  }else{
    return false
  }
}

export const sizeConvertInGb=(selectedFile)=>{
 return  (Math.round((selectedFile?.size / 1048576) * Math.pow(10, 2)) / Math.pow(10, 2))
}

export const getDateDifference=(startDate,endDate)=>{
  // Define the two dates
startDate = getDateTimestamp(startDate);
endDate = getDateTimestamp(endDate);
const date1 = new Date(startDate);
const date2 = new Date(endDate);
// Calculate the time difference in milliseconds
const timeDiff = Math.abs(date2.getTime() - date1.getTime());
// Convert the time difference from milliseconds to days
const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
return daysDiff; // Output: 70
}

export const formatBytes = (bytes) => {
  var units = ["GB", "MB", "KB", "Bytes"];
  var noOfUnitBytes = 1024 * 1024 * 1024;
  var i = 0;

  while (bytes / noOfUnitBytes < 1) {
    i++;
    noOfUnitBytes = noOfUnitBytes / 1024;
  }
  return (bytes / noOfUnitBytes).toFixed(2) + " " + units[i];
}

export const alphabeticalSortingLanguage=(myObject)=>{
  // Step 1: Convert the object to an array of key-value pairs
const keyValueArray = Object.entries(myObject);

// Step 2: Sort the array based on the keys (in alphabetical order)
keyValueArray.sort((a, b) => a[0].localeCompare(b[0]));

// Step 3: Convert the sorted array back to an object
const sortedObject = Object.fromEntries(keyValueArray);

// Step 4 (Optional): Sort the inner objects based on their keys (if needed)
for (const key in sortedObject) {
const innerObject = sortedObject[key];
const innerKeyValueArray = Object.entries(innerObject);
innerKeyValueArray.sort((a, b) => a[0].localeCompare(b[0]));
sortedObject[key] = Object.fromEntries(innerKeyValueArray);
}
 return sortedObject;
}

export const getIndesignVersionWarningType = (fileVersion, supportedVersion) => {
  var warningType = 0;
  try{

      // +1 if first higher , -1 if second higher , 0 if equal
      function compare(version1, version2) {
          var v1 = version1.replace(/[()]/g,'.').replace(/ /g,'').split('.');
          var v2 = version2.replace(/[()]/g,'.').replace(/ /g,'').split('.');
          var len = Math.min(v1.length, v2.length);
          var compareResult = 0;
          for(var i=0;i<len;i++){
              var ver1 = isNaN(v1[i]) ? 0 : parseInt(v1[i]);
              var ver2 = isNaN(v2[i]) ? 0 : parseInt(v2[i]);
              if(ver1 != ver2){
                    compareResult = ver1 > ver2 ? 1 : -1;
                    break;
              }
          }
          if(compareResult == 0){
              compareResult = v1.length > v2.length ? 1 : -1;
          }
          return compareResult;
      }

      if(compare(fileVersion,supportedVersion) > 0){//file version is higher then supported version
          warningType = 1;
      }else {
          var v1 = fileVersion.replace(/[()]/g,'.').replace(/ /g,'').split('.');
          var v2 = supportedVersion.replace(/[()]/g,'.').replace(/ /g,'').split('.');
          if(v1.length>0 && v2.length >0){
              var ver1 = isNaN(v1[0]) ? 0 : parseInt(v1[0]);
              var ver2 = isNaN(v2[0]) ? 0 : parseInt(v2[0]);
              if(ver1 != ver2){
                  if(ver2 - ver1 > 2){
                      warningType = 2;
                  }
              }
          }
      }
  }catch(e){
  }
  return warningType;
}

export const UserNameComparator = (user1, user2) => {
  const fullName1 = user1.firstName + " " + user1.lastName;
  const fullName2 = user2.firstName + " " + user2.lastName;
  return fullName1.localeCompare(fullName2);
}

export const ConvertNewLineToBr = (string) => {
  return string.replace(/\n/g, '<br/>')
}


export const getHourDifference=(startDate, endDate)=> {
  // Calculate the time difference in milliseconds
  const timeDifferenceMs = endDate - startDate;
  // Convert milliseconds to hours
  const hoursDifference = timeDifferenceMs / (1000 * 60 * 60);
  return hoursDifference;
}

export const getDayDifference=(startDate, endDate) =>{
  // Calculate the time difference in milliseconds
  const timeDifferenceMs = endDate - startDate;
  // Convert milliseconds to days
  const daysDifference = timeDifferenceMs / (1000 * 60 * 60 * 24);
  return daysDifference;
}
  
export const isDeliveryDueDateBeforeWorkspaceDate = (selectedDate, workspaceDueDate, userTimeZone) => {
  let delDueDate = utcDateTimeWithTimeZone(selectedDate, userTimeZone);
  let campDueDate = utcDateTimeWithTimeZone(workspaceDueDate, userTimeZone);
  return (new Date(campDueDate).getTime() - new Date(delDueDate).getTime()) > 0;
}


export const getCompositeAssetId=(asset)=> {
  if(asset.assetType == "Email") {
      return "EMAIL_" + asset.id;
  } else if(asset.assetType == "Form") {
      return "FORM_" + asset.id;
  } else if(asset.assetType == "LandingPage") {
      return "LANDING_PAGE_" + asset.id;
  }
  return null;
}

export const  getInProgressAssetsById=(thisAsset,assetId)=> {
   var inProgressAssetModels = this.inProgressAssets.filter(function(asset) {
    return ((asset.get("assetType").code + "_" + asset.get("externalId")) === assetId) ;
});

if(inProgressAssetModels && inProgressAssetModels.length > 0) {
    return inProgressAssetModels;
}
return null;
}

export const getAssetType=(assetType)=> {
  // to map between the string values eloqua gives us and the enum values we use
  if (assetType === "form") {
      return "FORM";
  } else if (assetType === "landingPage") {
      return "LANDING_PAGE";
  } else if (assetType === "email") {
      return "EMAIL";
  }
  return null;
}

export const checkLanguageStatus=(languages)=>{
  let status=true
  if(languages && languages !==undefined ){
  languages.forEach(data=>{
    if(data===""){
      status=false; 
      return status;
    }
  })
}
  return status;
}


export const generateRelativeDateString=(date)=> {
  date = getDateTimestamp(date);
  const compareDate = moment(date);
  const now = moment();
  const isFuture = compareDate.isAfter(now);
  const diff = isFuture ? moment.duration(compareDate.diff(now)) : moment.duration(now.diff(compareDate));
  let relativeString = '';
  if (diff.asYears() >= 1) {
    relativeString = Math.floor(diff.asYears()) + ' year' + (Math.floor(diff.asYears()) >= 2 ? 's' : '');
  } else if (diff.asMonths() >= 1) {
    relativeString = Math.floor(diff.asMonths()) + ' month' + (Math.floor(diff.asMonths()) >= 2 ? 's' : '');
  } else if (diff.asWeeks() >= 1) {
    relativeString = Math.floor(diff.asWeeks()) + ' week' + (Math.floor(diff.asWeeks()) >= 2 ? 's' : '');
  } else if (diff.asDays() >= 1) {
    relativeString = Math.floor(diff.asDays()) + ' day' + (Math.floor(diff.asDays()) >= 2 ? 's' : '');
  } else if (diff.asHours() >= 1) {
    relativeString = Math.floor(diff.asHours()) + ' hour' + (Math.floor(diff.asHours()) >= 2 ? 's' : '');
  } else if (diff.asMinutes() >= 1) {
    relativeString = Math.floor(diff.asMinutes()) + ' minute' + (Math.floor(diff.asMinutes()) >= 2 ? 's' : '');
  } else {
    return 'Just now';
  }

  if (isFuture) {
    return `From now ${relativeString}`;
  } else {
    return `${relativeString} ago`;
  }
}

export const TIME_LIST_DATA = [
  { value: -1, label: "What time",isDisabled: true },
  { value: 0, label: "Midnight" ,isDisabled: false},
  { value: 1, label: "1 am",isDisabled: false },
  { value: 2, label: "2 am" ,isDisabled: false},
  { value: 3, label: "3 am" ,isDisabled: false},
  { value: 4, label: "4 am" ,isDisabled: false},
  { value: 5, label: "5 am" ,isDisabled: false},
  { value: 6, label: "6 am" ,isDisabled: false},
  { value: 7, label: "7 am" ,isDisabled: false},
  { value: 8, label: "8 am" ,isDisabled: false},
  { value: 9, label: "9 am" ,isDisabled: false},
  { value: 10, label: "10 am" ,isDisabled: false},
  { value: 11, label: "11 am" ,isDisabled: false},
  { value: 12, label: "Noon" ,isDisabled: false},
  { value: 13, label: "1 pm" ,isDisabled: false},
  { value: 14, label: "2 pm" ,isDisabled: false},
  { value: 15, label: "3 pm" ,isDisabled: false},
  { value: 16, label: "4 pm" ,isDisabled: false},
  { value: 17, label: "5 pm" ,isDisabled: false},
  { value: 18, label: "6 pm" ,isDisabled: false},
  { value: 19, label: "7 pm" ,isDisabled: false},
  { value: 20, label: "8 pm" ,isDisabled: false},
  { value: 21, label: "9 pm" ,isDisabled: false},
  { value: 22, label: "10 pm" ,isDisabled: false},
  { value: 23, label: "11 pm" ,isDisabled: false}
]

export const disabledSelectStyle = {
    option: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? 'gray' : 'black', // Change color of disabled options
        cursor: state.isDisabled ? 'not-allowed' : 'default', // Change cursor style for disabled options
        // Add more custom styling properties as needed
    }),
};


// if user time zone IST and select 8pm then utc 2:30PM
//if user time zone PST and select 8pm then utc 12pm

export const timeStamp=(userDate,userTimezone)=>{
  userDate = getDateTimestamp(userDate);
  const formattedDate = moment(userDate).format('YYYY-MM-DDTHH:mm:ss')
  const userDateTime = moment.tz(formattedDate, userTimezone);
  const utcTimestamp = userDateTime.utc().valueOf();
   return {"utcTimestamp":utcTimestamp}
}

export const getTimeStamp=(utcTimestamp)=>{
   return {"utcTimestamp":utcTimestamp}
}

export const projectCreationSteps = ["Source Material Step 1",
	"Source Material Step 2",
	"Upload Image Step",
	"Language and Reference Material",
	"Project Information",
	"Translation Request",
	"Workflow Step 1",
	"Workflow Step 2",
	"Project Summary",
	"Finish And Request Translation"];

export const projectPriority = {
  'HIGHEST':'Highest (1)',
  'HIGH':'High (2)',
  'MEDIUM':'Medium (3)',
  'LOW':'Low (4)',
  'LOWEST':'Lowest (5)',
  '':'N/A'
}

export const translationModeCodes = {
  CLONE_ASSET: "New Asset",
  CLONE_PROGRAM: "New Program",
  DYNAMIC_CONTENT: "Dynamic Content"
};

export const roundToFullHour = (date) => {
  if(date.getMinutes() > 0 || date.getSeconds() > 0 || date.getMilliseconds() > 0) {
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    date.setHours(date.getHours()+1);
  }
  return date;
};

export const isSameDay = (date1, date2) => {
  return date1.getFullYear() == date2.getFullYear() && 
					date1.getMonth() == date2.getMonth() &&
					date1.getDate() == date2.getDate();
};

export const wrapperText = (value, prefix, suffix) => {
    if (value) {
        return prefix + value + suffix;
    }
    return "";
}

 export const getRangeDates = (range)=>{
  let dates = range.dates ? [range.dates[0], range.dates[1]] : null;
  if(range.code !== "custom" || range.dates === null){
      const startDate = moment().subtract(range.value, range.unit).startOf('day');
      const endDate = currentDate();
      dates = [startDate?._d, endDate._d];;
  }
  return dates;
}

export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
      return false;
  }
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (let key of keys1) {
    if (!keys2.includes(key)) {
        return false;
    }
    const val1 = obj1[key];
    const val2 = obj2[key];
    if (Array.isArray(val1) && Array.isArray(val2)) {
        if (!deepEqual(val1.slice().sort(), val2.slice().sort())) {
            return false;
        }
    } else if (!deepEqual(val1, val2)) {
        return false;
    }
  }
  return true;
}

export const isEqualOrBlank = (value1, value2) => {
    return isEqualOrBlankSingle(value1, value2) && isEqualOrBlankSingle(value2, value1);
}

const isEqualOrBlankSingle = (value1, value2) => {
    for (let key in value1) {
        if (value1[key] instanceof Array) {
            if (value1[key].length > 0) {
                if (!value2) return false;
                if (value1[key].length !== value2[key].length || value1[key].sort().join(",") !== value2[key].sort().join(",")) {
                    return false;
                }
            }
        } else if (value1[key] instanceof Object) {
            return isEqualOrBlank(value1, value2);
        } else if (value1[key] !== value2[key]) {
            return false;
        }
    }
    return true;
}

export const isEmptyString = (value) => {
    return value === null || value === undefined || value === "" || (typeof value === "string" && value.trim() === "");
}

export const getHTMLfromText = (text) => {
  const html = text?.split('\n').map((line, index) => (
    <span key={index}>
      {line}
      {index < text.split('\n').length - 1 && <br />}
    </span>
  ));

  return (
    <p>{html}</p>
  );
};